import React, { Component } from 'react';
import { connect } from 'react-redux';
import ActionLoader from 'Components/ActionLoader';
import Sticky from 'Components/Sticky';
import { ReactComponent as EditIcon } from 'Icons/edit.svg';
import {ReactComponent as DeleteIcon} from 'Icons/delete.svg';
import { GET_SECONDARY_CONTRACTS_LIST, DELETE_SECONDARY_CONTRACT_RFQ, GET_VENDOR_LIST } from 'Constants/actionConstants';
import moment from 'moment';
import Dropdown from 'Components/Dropdown/dropdown';
import { getUser } from 'Utils/storage';
import Select from 'react-select';
import { DateRangePicker} from 'react-dates';
import { ABFRL, PANTALOONS } from 'Constants/commonConstants';
import { getItemFromLocal } from 'Utils/localStorage';
import { isSapDPL } from 'Utils/index';
import ScreenTimeTrack from "Components/Common/ScreenTimeTrack/index";
import { screenInfoDetails } from 'Constants/screenInfoDetailsConstants';
class SecondaryContracts extends Component {
    constructor(){
        super();
        this.state = {
            limit: 50,
            offset: 0,
            selectedTransporter: getItemFromLocal('selectedTransporter') || null,
            startDate:null,
            endDate:null,
            focusedInput:false
        }
    }

    componentDidMount() {
        this.getSecondaryContracts();

        const { dispatch, match } = this.props;
        dispatch({
            type: GET_VENDOR_LIST,
            params: {
                companyId: getUser().companyId
            }
        });
    }

    getSecondaryContracts = () => {
        const { dispatch } = this.props;
        const { limit, offset,selectedTransporter,startDate,endDate } = this.state;

        dispatch({
            type: GET_SECONDARY_CONTRACTS_LIST,
            params: {
                limit: limit,
                offset: offset,
                transporterId:selectedTransporter?selectedTransporter.company_id: '',
                from:startDate?startDate.valueOf() :'',
                to:endDate?endDate.valueOf() :'',
            }
        })
    }

    addContracts = () => {
        const { history } = this.props;
        history.push('/addSecondaryContract');
    }

    onDeleteRFQ = (rfqId) => {
        const { dispatch } = this.props;
        dispatch({
            type: DELETE_SECONDARY_CONTRACT_RFQ,
            data: {
                rfqId
            },
            onSuccess: this.getSecondaryContracts
        })
    }

    onViewClick = (rfqId, viewOrEdit) => {
        const { history } = this.props;
        history.push(`/contracts/${rfqId}/${viewOrEdit}`);
    }
    shouldRenderFilters=()=>{
        const isPantaloons = PANTALOONS.includes(getUser().companyId);
        if(isPantaloons){
            return true;
        }
        return false;
    }

    goToNextPage = () => {
        this.setState({
            offset: this.state.offset + this.state.limit
        }, () => {
            this.getSecondaryContracts();
        });
    }

    goToPrevPage = () => {
        if(this.state.offset != 0) {
            this.setState({
                offset: this.state.offset - this.state.limit
            }, () => {
                this.getSecondaryContracts();
            });
        }
    }

    render() {
        const { 
            loader,
            secondaryContracts,
            vendorlist
        } = this.props;
        const { selectedTransporter,startDate,endDate,focusedInput } = this.state;
        return (
            <div style={{ backgroundColor: "#e3e9ff", height: "820px" }}>
                {loader && 
                    <ActionLoader 
                        fixed={true}
                    />
                }
                
                <Sticky>
                    <div className='pv-20 ph-20'>
                        <ScreenTimeTrack
                            screenInfoDetailsItem={
                                screenInfoDetails.SECONDARY_CONTRACTS_SCREEN
                            }
                        />
                        <div className='flex flex-between'>
                            <div className='fs-28 fBold pt-10'>Contract List</div>
                            <button className='ht-50 wt-180 bg-dblue white-color fs-16 fSemibold curP' onClick={this.addContracts}>Add Contract</button>
                        </div>
                        {this.shouldRenderFilters()&&
                        <div className='flex'>
                            <div className='wt-400 mr-20'>
                                <div className='fs-16 fSemibold mb-2'>Transporter Name</div>
                                <Select
                                    className="wt-300"
                                    placeholder="Select Transporter"
                                    value={selectedTransporter}
                                    options={vendorlist}
                                    getOptionLabel={(option) => option.company}
                                    getOptionValue={(option) => option.company_id}
                                    isClearable={true}
                                    isSearchable={true}
                                    onChange={(option) => {
                                        localStorage.setItem('selectedTransporter', JSON.stringify(option));
                                        this.setState(
                                            { selectedTransporter: option },
                                            ()=>{
                                                this.getSecondaryContracts();
                                            }
                                            )
                                        }}
                                />
                            </div>

                            <div className='wt-400 mr-20'>
                                <div className='fs-16 fSemibold mb-2'>Contract Tenure</div>
                                <DateRangePicker
                                    startDate={startDate}
                                    endDate={endDate}
                                    onDatesChange={({ startDate, endDate }) =>
                                    this.setState({ startDate, endDate }, () => {
                                        this.getSecondaryContracts();
                                    })
                                    }
                                    focusedInput={focusedInput}
                                    onFocusChange={(focusedInput) => this.setState({ focusedInput })}
                                    isOutsideRange={() => false}
                                />
                            </div>
                        </div>}
                        <table className={'secondary-contract-table fs-16'} style={{ boxShadow: 'rgba(136, 165, 300, 0.6) 0px 0px 5px 0px, rgba(255, 255, 255, 0.7) 0px 0px 5px 0px', width: "100%", borderSpacing: '0px', marginTop: "30px" }} cellSpacing={0.5}>
                            <thead className="ht-40 fs-16 fBold mr-5 mt-10 curP table-bg-blue white-color">
                                <tr>
                                    <th style={{'borderRight': '1px solid #528AEA'}}>Contract Name</th>
                                    <th style={{'borderRight': '1px solid #528AEA'}}>Transporter Name</th>
                                    <th style={{'borderRight': '1px solid #528AEA'}}>Contract Tenure</th>
                                    <th style={{'borderRight': '1px solid #528AEA'}}>Service Type</th>
                                   {!isSapDPL() && <th style={{'borderRight': '1px solid #528AEA'}}>Distribution Type</th>}
                                    <th style={{'borderRight': '1px solid #528AEA'}}></th>
                                    <th style={{'borderRight': '1px solid #528AEA'}}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(secondaryContracts || []).map((data, index) => {
                                    return(
                                        <tr className='fs-16 fSemibold'>
                                            <td className='pv-5 ph-5 tCenter'>{data.rfq_name}</td>
                                            <td className='pv-5 ph-5 tCenter'>{data.vendor_name}</td>
                                            <td className='pv-5 ph-5 tCenter'>
                                                <div className='mb-5'><span className='dark-blue mr-5'>Start</span>  {data.contract_tenure_from && moment(data.contract_tenure_from).format('DD/MM/YYYY')}</div>
                                                <div><span className='dark-blue  mr-5'>End</span>  {data.contract_tenure_to && moment(data.contract_tenure_to).format('DD/MM/YYYY')}</div></td>
                                            <td className='pv-5 ph-5 tCenter'>{data.contract_type_name}</td>
                                            {!isSapDPL() && <td className='pv-5 ph-5 tCenter'>{data.distribution_mode_name}</td>}
                                            <td className='pv-5 ph-5 tCenter'>
                                                <button className='ht-30 wt-70 button-bg-color white-color fs-16 fSemibold' onClick={() => this.onViewClick(data.rfq_id, true)}>View</button>
                                            </td>
                                            <td className='pv-5 ph-5 tCenter'>
                                                <EditIcon className="wt-15 ht-15 ml-5 curP fBold" onClick={() => this.onViewClick(data.rfq_id, false)}/>
                                                <DeleteIcon className="wt-15 ht-15 ml-5 curP fBold" onClick={() => this.onDeleteRFQ(data.rfq_id)}/>
                                            </td>
                                        </tr>)
                                    }
                                )}
                            </tbody>
                        </table>
                        <div className={'mt-20'}>
                            {this.state.offset !=0 && <button className='ht-30 wt-100 bg-dblue white-color fs-16 fSemibold curP fLeft' onClick={this.goToPrevPage}>Previous</button>}
                            <button className='ht-30 wt-100 bg-dblue white-color fs-16 fSemibold curP fRight' onClick={this.goToNextPage}>Next</button>
                        </div>
                    </div>
                </Sticky>
            </div>
        )
    }
}

const mapStateToProps = ({ contracting,constants }) => {
    return {
        loader: contracting.loader,
        secondaryContracts: contracting.secondaryContracts,
        vendorlist: constants.vendorList || [],
    }
}
export default connect(mapStateToProps)(SecondaryContracts);